<div class="informe-operativo">
  <div *ngIf="data">
    <!-- Sección de KPIs -->
    <div class="seccion-kpis">
      <div class="tarjeta-kpi completada">
        <div class="etiqueta-kpi">Citas Completadas</div>
        <div class="valor-kpi">{{ data.kpis.citasCompletadas }}</div>
        <div class="unidad-kpi">{{ (getCompletedPercentage() | number: '1.0-0') }}% del total</div>
      </div>

      <div class="tarjeta-kpi cancelada">
        <div class="etiqueta-kpi">Citas Canceladas</div>
        <div class="valor-kpi">{{ data.kpis.citasCanceladas }}</div>
        <div class="unidad-kpi">{{ (getCancelledPercentage() | number: '1.0-0') }}% del total</div>
      </div>

      <div class="tarjeta-kpi nopresentada">
        <div class="etiqueta-kpi">Citas No Presentadas</div>
        <div class="valor-kpi">{{ data.kpis.citasNoPresentadas }}</div>
        <div class="unidad-kpi">{{ (getNoShowPercentage() | number: '1.0-0') }}% del total</div>
      </div>

      <div class="tarjeta-kpi vacia">
        <div class="etiqueta-kpi">Horas Vacías</div>
        <div class="valor-kpi">{{ data.kpis.horasVacias | number: '1.1-1' }}</div>
        <div class="unidad-kpi">horas</div>
      </div>
    </div>

    <!-- Gráfico de Distribución de Citas -->
    <div class="seccion-grafico">
      <h3>Distribución de Citas</h3>
      <div class="contenedor-grafico">
        <canvas baseChart
          [data]="statusChartData"
          [labels]="statusChartLabels"
          [chartType]="statusChartType"
          [colors]="statusChartColors"
          [options]="statusChartOptions">
        </canvas>
      </div>
    </div>

    <!-- Tabla Detallada por Empleado -->
    <div class="seccion-tabla">
      <h3>Métricas Operativas por Empleado</h3>
      <div *ngIf="data.filas.length > 0; else sinRegistros" class="tabla-responsiva">
        <table class="tabla-informe">
          <thead>
            <tr>
              <th>Empleado</th>
              <th>Completadas</th>
              <th>Canceladas</th>
              <th>No Presentadas</th>
              <th>Horas Vacías</th>
              <th>Total de Citas</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data.filas; trackBy: trackByEmployee">
              <td><strong>{{ row.nombreEmpleado }}</strong></td>
              <td class="metrica-completada">{{ row.citasCompletadas }}</td>
              <td class="metrica-cancelada">{{ row.citasCanceladas }}</td>
              <td class="metrica-nopresentada">{{ row.citasNoPresentadas }}</td>
              <td>{{ row.horasVacias | number: '1.1-1' }} hrs</td>
              <td>
                {{
                  row.citasCompletadas +
                    row.citasCanceladas +
                    row.citasNoPresentadas
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #sinRegistros>
        <p class="sin-datos">No hay datos operativos disponibles</p>
      </ng-template>
    </div>
  </div>
  <div *ngIf="!data" class="sin-datos">No hay datos disponibles</div>
</div>
